import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { RECAPTCHA_SITE_KEY_V3 } from "shared/util/constants";
import OnDOMReady from "shared/util/OnDOMReady";
import ReduxDevTools from "shared/util/ReduxDevTools";

import reducers from "./reducers";
import analyticsMiddleware from "./analyticsMiddleware";
import App from "./App";

OnDOMReady(() => {
	const store = createStore(
		reducers,
		compose(
			applyMiddleware(thunk, analyticsMiddleware),
			ReduxDevTools("Logged Out"),
		),
	);

	render(
		<Provider store={store}>
			<GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY_V3}>
				<App />
			</GoogleReCaptchaProvider>
		</Provider>,
		document.getElementById("root"),
	);
});



// WEBPACK FOOTER //
// ./src/pages/loggedout/index.js